import { render, staticRenderFns } from "./CodeManage.vue?vue&type=template&id=4ad1d764&scoped=true"
import script from "./CodeManage.vue?vue&type=script&lang=js"
export * from "./CodeManage.vue?vue&type=script&lang=js"
import style0 from "./CodeManage.vue?vue&type=style&index=0&id=4ad1d764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad1d764",
  null
  
)

export default component.exports